import { create } from 'zustand';

interface IconRect {
    x: number;
    y: number;
    width: number;
    height: number;
}

interface AuthTransitionState {
    phase: 'idle' | 'to-center' | 'at-center' | 'to-sidebar' | 'done';
    loginIconRect: IconRect | null;
    sidebarIconRect: IconRect | null;
    startTransition: (rect: IconRect) => void;
    moveToCenter: () => void;
    setSidebarRect: (rect: IconRect) => void;
    moveToSidebar: () => void;
    finish: () => void;
    reset: () => void;
}

export const useAuthTransitionStore = create<AuthTransitionState>((set) => ({
    phase: 'idle',
    loginIconRect: null,
    sidebarIconRect: null,
    startTransition: (rect) => set({ phase: 'to-center', loginIconRect: rect }),
    moveToCenter: () => set({ phase: 'at-center' }),
    setSidebarRect: (rect) => set({ sidebarIconRect: rect }),
    moveToSidebar: () => set({ phase: 'to-sidebar' }),
    finish: () => set({ phase: 'done' }),
    reset: () => set({ phase: 'idle', loginIconRect: null, sidebarIconRect: null }),
}));
